module.exports = __webpack_public_path__ + "static/becoming-7c88d505ea7e1d4464ec5be86cbe9dc8.jpg";